import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../helper/DateFormat";
import { IRFACustomerProductTableProps } from "../../interfaces/rfa-customer-product";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";
import { LinkRegular } from "@fluentui/react-icons";

export default function RFACustomerProductTable(props: IRFACustomerProductTableProps) {
  const columns: GridColDef[] = [
    {
      headerName: "CRM Link",
      field: "crmLink",
      width: 130,
      sortable: true,
      renderCell: (params) => (
        <a
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 26,
            cursor: "pointer"
          }}
          href={params.row.crmLink}
          target="_blank"
          rel="noopener noreferrer"
          title={params.row.crmLink}
          tabIndex={params.row.tabIndex}
        >
          <LinkRegular />
        </a>
      )
    },
    {
      headerName: "Product Name",
      field: "productName",
      width: 290,
      sortable: true
    },
    {
      headerName: "RFA Title",
      field: "rfaTitle",
      width: 220,
      sortable: true
    },
    {
      headerName: "Request Description",
      field: "requestDescription",
      width: 300,
      sortable: true
    },
    {
      headerName: "RFA Source",
      field: "rfaSource",
      width: 150,
      sortable: true
    },
    {
      headerName: "Request Type",
      field: "requestType",
      width: 200,
      sortable: true
    },
    {
      headerName: "RFA Status",
      field: "rfaStatus",
      width: 180,
      sortable: true
    },
    {
      headerName: "Triage Status",
      field: "triageStatus",
      width: 180,
      sortable: true
    },
    {
      headerName: "Engagement Summary",
      field: "engagementSummary",
      width: 180,
      sortable: true
    },
    {
      headerName: "Assigned To",
      field: "assignedTo",
      width: 180,
      sortable: true
    },
    {
      headerName: "Requestor",
      field: "requestor",
      width: 180,
      sortable: true
    },
    {
      headerName: "Created On",
      type: "date",
      field: "createdOn",
      width: 120,
      sortable: true,
      valueGetter: (value, row) => new Date(row.createdOn),
      renderCell: (params) => formatDate(params.row.createdOn)
    },
    {
      headerName: "Modified On",
      type: "date",
      field: "modifiedOn",
      width: 120,
      sortable: true,
      valueGetter: (value, row) => new Date(row.modifiedOn),
      renderCell: (params) => formatDate(params.row.modifiedOn)
    }
  ];

  const showNoData = () => {
    const rootStyle = {
      display: "flex",
      justifyContent: "center",
      alightItems: "center",
      padding: 200
    };
    return <div style={rootStyle}>{`RFA Customer Product details are not available for ${props.tenantName}`}</div>;
  };


  return props?.tableData && props?.tableData.length > 0 ? (
    <div style={{ height: 600, marginLeft: 8, marginRight: 8 }}>
      <CustomDataGrid
        columns={columns}
        enableUrlParams
        kustoLink={props.rfaCustomerProductKustoLink}
        TabName={`Customer View - Customer Engagements Tab - RFA Table for ${props.tenantName}`}
        exportCsvButtonProps={{
          fileNamePrefix: "customer-engagements"
        }}
        getRowId={(row) => row.rowId}
        rows={{
          values:
            props.tableData?.map((row, index) => ({
              ...row,
              rowId: row.productName + "-" + (index + 1)
            })) ?? [],
          count: props.tableData?.length ?? 0
        }}
        showCellVerticalBorder
      />
    </div>
  ) : (
    showNoData()
  );
}
